import firebase from "firebase/app";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FB_API_KEY_FALCONI,
  authDomain: process.env.VUE_APP_FB_AUTH_DOMAIN_FALCONI,
  databaseURL: process.env.VUE_APP_FB_DB_URL_FALCONI,
  projectId: process.env.VUE_APP_FB_PROJECT_ID_FALCONI,
  storageBucket: process.env.VUE_APP_FB_STORAGE_BUCKET_FALCONI,
  appId: process.env.VUE_APP_FB_APP_ID_FALCONI,
};
const falconi = firebase.initializeApp(firebaseConfig, "falconi");

export default falconi;
